module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAC0AgMAAADA0NmyAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEUASMz////XKChiLYozAAAAAWJLR0QB/wIt3gAAAAd0SU1FB+kEHRcvNfeqgNMAAABeSURBVGje7dYxCoAwFETB33i/NHs/65xSAjaKhRhEhHn91LtV55akj5JWT+J5nud5nud5nud5nucP5aLd36jx/JTvU608z/O/9faD/9L7zzzP8zzP8zzP8zzP86/6DdydwMrSXLFzAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI1LTA0LTI5VDIzOjQ3OjUzKzAwOjAw0JPWqAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNS0wNC0yOVQyMzo0Nzo1MyswMDowMKHObhQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/bd.png
// module id = Jy6I
// module chunks = 128